import {intTelConfig} from "../utils/intTelConfig";
import clientCardBarCode from "../utils/clientCardBarCode";

export default function initializeCardDashboard() {
    document.querySelectorAll('.block-card-dashboard').forEach(function (block) {
        new CardDashboardClass(block);
    });
}

class CardDashboardClass {
    constructor(block) {
        this.block = block;
        this.init();
        this.phoneInput = this.block.querySelector('input#phone');
        this.errors = {};
    }

    init() {
        console.log('ddd');
        this.initFormRegister();
        this.showCard();
        this.initEditForm();
    }

    showCard() {
        if(this.block.querySelector('.card-dashboard__barcode')) {
            clientCardBarCode(this.block.querySelector('.card-dashboard__barcode--desktop'));
            clientCardBarCode(this.block.querySelector('.card-dashboard__barcode--mobile'));
        }
    }

    initFormRegister() {
        if(!this.block.querySelector('#card-register-form')) {
            return;
        }
        import('intl-tel-input').then(({default: intlTelInput}) => {
            const iti = intlTelInput(this.phoneInput, intTelConfig);
            this.block.querySelector('button#register-card').addEventListener('click', (e) => {
                this.phoneInput.value = iti.getNumber();
                 this.registerCardEvent(e)
            });
        });


    }

    initEditForm() {
        if(!this.block.querySelector('#card-edit-form')) {
            return;
        }
        import('intl-tel-input').then(({default: intlTelInput}) => {
           const iti = intlTelInput(this.phoneInput, intTelConfig);
        });


        this.block.querySelector('button#edit-card').addEventListener('click', (e) => {
            this.phoneInput.value = iti.getNumber();
            this.updateCardEvent(e)
        });
    }

    updateCardEvent(e) {
        e.preventDefault();
        const form = this.block.querySelector('#card-edit-form');
        if (this.validateForm(form)) {
            form.submit();
        }
    }

    registerCardEvent(e) {
        e.preventDefault();
        const form = this.block.querySelector('#card-register-form');
        if (this.validateForm(form)) {
            form.submit();
        }
    }

    validateForm(form) {
        const inputs = form.querySelectorAll('input');
        this.errors = {};
        inputs.forEach((input) => {
            if (input.required === true) {
                if(input.type === 'checkbox' && input.checked === false
                || input.value === '') {
                    input.classList.add('error');
                    const inputLabel = input.closest('.form-row').querySelector('label').innerText;
                    if (!inputLabel) {
                        return;
                    }
                    this.errors[input.id] = 'Pole <strong>' + inputLabel.replace('*', '') +
                        '</strong> jest wymagane';
                }
            } else {
                input.classList.remove('error');
            }

        });

        if (Object.keys(this.errors).length > 0) {
            this.showErrors();
            return false;
        }
        return true;
    }

    showErrors() {
        const errorsContainer = this.block.querySelector('.errors');
        errorsContainer.innerHTML = '';
        Object.keys(this.errors).forEach((key) => {
            const error = document.createElement('div');

            // woocommerce notice
            error.classList.add('woocommerce-error');
            error.classList.add('mb-3');
            error.innerHTML = this.errors[key];
            errorsContainer.appendChild(error);

        });
    }
}
